// context/PatrolTaskContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import { useForm } from 'react-hook-form';

const PatrolTaskContext = createContext();

// Custom hook to use the context
export const usePatrolTaskContext = () => useContext(PatrolTaskContext);

// Provider component to wrap around the app or component tree
export const PatrolTaskProvider = ({ children }) => {
  // Manage the state here
  const [tasks, setTasks] = useState([]);
  const [currentTaskIndex, setCurrentTaskIndex] = useState(null);
  const [isCopingTask, setIsCopingTask] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [shiftEndTime, setShiftEndTime] = useState(null);
  const [deletePatrolTaskModal, setDeletePatrolTaskModal] = useState(false);
  // Drawer open/close state
  const [drawerOpen, setDrawerOpen] = useState(false);
  // React hook form setup
  const { control, handleSubmit, reset, getValues } = useForm({
    mode: 'onBlur',
    defaultValues: {
      title: '',
      startTime: null,
      details: '',
    },
  });

  // Memoize the value to prevent re-creating the object on each render
  const value = useMemo(
    () => ({
      tasks,
      setTasks,
      currentTaskIndex,
      setCurrentTaskIndex,
      isCopingTask,
      setIsCopingTask,
      anchorEl,
      setAnchorEl,
      drawerOpen,
      setDrawerOpen,
      control,
      handleSubmit,
      reset,
      getValues,
      startTime,
      setStartTime,
      shiftEndTime,
      setShiftEndTime,
      deletePatrolTaskModal,
      setDeletePatrolTaskModal,
    }),
    [
      tasks,
      currentTaskIndex,
      isCopingTask,
      anchorEl,
      drawerOpen,
      handleSubmit,
      control,
      reset,
      getValues,
      startTime,
      shiftEndTime,
      deletePatrolTaskModal,
    ],
  );

  // Provide the state and setter functions via context
  return <PatrolTaskContext.Provider value={value}>{children}</PatrolTaskContext.Provider>;
};

// Add prop types validation for children
PatrolTaskProvider.propTypes = {
  children: PropTypes.node.isRequired, // Validate children prop
};

export default PatrolTaskContext;
